/* Sequential Racing – product page extras merged into the redesign (Claude, Oct 2026).
   Only what the redesign skin does not already do: a clear "Added to cart" confirmation on the button
   and a small price pop when an option changes the price. Nothing happens for visitors who prefer reduced motion,
   except the confirmation, which shows without animation. */
(function () {
  if (window.SRProductUX) return;
  window.SRProductUX = true;
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var main = document.querySelector('.section-product-page') || document.querySelector('[id^=MainProduct]');
    if (!main) return;

    /* 1. "Added to cart" confirmation on the main and sticky buttons */
    var tick = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
    var showAdded = function (btn) {
      if (!btn) return;
      var old = btn.querySelector('.srp-added-msg');
      if (old) old.remove();
      var msg = document.createElement('span');
      msg.className = 'srp-added-msg';
      msg.setAttribute('aria-hidden', 'true');
      msg.innerHTML = tick + '<span>Added to cart</span>';
      btn.appendChild(msg);
      setTimeout(function () { msg.remove(); }, 2000);
    };
    /* the theme declares PUB_SUB_EVENTS with const, so it is a global name but not a window property */
    var events = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null;
    var onAdded = function (e) {
      if (!e || e.source !== 'product-form') return;
      showAdded(main.querySelector('.product-form__submit'));
      showAdded(document.querySelector('#sticky-cta .button'));
    };
    if (typeof window.subscribe === 'function' && events) {
      if (events.cartAdd) window.subscribe(events.cartAdd, onAdded);
      else window.subscribe(events.cartUpdate, onAdded);
    }

    /* 2. Price pop when a different option changes the price */
    if (!RM) {
      var getPrice = function () { return main.querySelector('[id^="price-"]'); };
      var priceWrap = getPrice();
      if (priceWrap) {
        var last = priceWrap.textContent.replace(/\s+/g, ' ').trim();
        new MutationObserver(function () {
          priceWrap = getPrice();
          if (!priceWrap) return;
          var now = priceWrap.textContent.replace(/\s+/g, ' ').trim();
          if (now === last) return;
          last = now;
          var p = priceWrap.querySelector('.price-item--sale, .price-item--regular') || priceWrap;
          p.classList.remove('srp-pop'); void p.offsetWidth; p.classList.add('srp-pop');
        }).observe(main, { childList: true, subtree: true, characterData: true });
      }
    }
  });
})();
